import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import VueCookies from 'vue-cookies'
import VueWorker from 'vue-worker'
import outjs from '../src/assets/js/out.js'
import OctopusList from './components/Engine/Framework/ListEngine'
import OctopusItem from './components/Engine/Framework/ItemEngine'
import OctopusControl from './components/Engine/Framework/ControlEngine'
// import OctopusControlRichText from './components/Engine/Framework/ControlForRichText'
import OctopusDialog from './components/Engine/Framework/DialogEngine'
import {oEngine} from '../src/assets/octopus/main.js'

/* quill register */
import VueQuillEditor,{ Quill } from 'vue-quill-editor'
import ImageResize from 'quill-image-resize-module'
Quill.register('modules/imageResize', ImageResize);
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.config.productionTip = false;
Vue.prototype.$OutTestJS = outjs;
Vue.prototype.$Plug = {HK: outjs, Test: outjs};
Vue.use(VueResource);
Vue.use(VueCookies);
Vue.use(VueWorker);
Vue.use(VueQuillEditor);
Vue.component("o-list", OctopusList);
Vue.component("o-item", OctopusItem);
Vue.component("o-control", OctopusControl);
// Vue.component("o-control-rich-text", OctopusControlRichText);
Vue.component("o-dialog", OctopusDialog);
let vm = new Vue({
  el: '#app', router, template: '<App/>', components: {App}, data: {octopus: null,}, created: function () {
    if (!this.octopus) {
      this.octopus = new oEngine(this)
    }
  }, beforeUpdate: function () {
    this.octopus.tips.debug("Vue.vue执行了beforeUpdate事件。")
  }, beforeRouteEnter: function (to, from, next) {
    this.octopus.tips.debug("Vue.vue执行了beforeRouteEnter事件。")
  }, mounted: function () {
    this.octopus.tips.debug("Vue.Main执行了mounted事件。")
  }, activated: function () {
    this.octopus.tips.debug("Vue.Main执行了activated事件。")
  }, computed: {}, watch: {
    $route(to, from) {
      this.octopus.router.set(to);
      this.octopus.tips.debug("Main.js路由：" + to.path + " - " + from.path + ", octopus.route: " + this.octopus.router.get().fullPath + "判断是否具有用户权限，如果有则过，没有则跳转501（没有权限）页面。")
    }, 'octopus.passport.name': function (newv, oldv) {
      this.octopus.tips.debug("[watch] octopus.passport.name: " + JSON.stringify(newv));
      if (oldv != undefined) {
        this.octopus.passport.encryption = false;
        this.octopus.passport.password = "";
        this.octopus.passport.appKey = "";
        this.octopus.passport.token = "";
        this.octopus.passport.id = -1;
        this.octopus.passport.tab = [{id: -1, url: "/main/platform/dashboard", name: ""}];
        this.octopus.passport.tabCurrentName = "M_0";
        this.octopus.passport.system = null;
        this.octopus.passport.menu = []
      }
    }, 'octopus.passport.password': function (newv, oldv) {
      this.octopus.tips.debug("[watch] octopus.passport.password: " + JSON.stringify(newv));
      if (oldv != undefined && this.octopus.passport.encryption == true) {
        this.octopus.passport.encryption = false;
        this.octopus.passport.appKey = "";
        this.octopus.passport.token = "";
        this.octopus.passport.id = -1
      }
    }, 'octopus.passport': {
      handler(newv, oldv) {
        this.octopus.tips.debug("[watch] octopus.passport: " + JSON.stringify(newv));
        if (oldv != undefined) {
          if (!this.octopus.tools.IsNullOrEmpty(newv)) {
            this.octopus.request.localstorage.set("user_passport", newv)
          }
        }
      }, deep: true
    }
  }
});
vm.$OutTestJS.getout("AAA", vm);
outjs.getout("BBB", vm);



// WEBPACK FOOTER //
// ./src/main.js